/**
 * Snapshot de Contratos Marco en localStorage["pmis.contratosDefault"].
 * Cargado por seed.ts cuando la DB está vacía (sustituye a sampleContratos).
 */

import type { ContratoMarco } from "@app-types/entities";

const STORAGE_KEY_DEFAULT = "pmis.contratosDefault";

export function leerContratosDefault(): ContratoMarco[] | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_DEFAULT);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return null;
    const ok = parsed.every(
      (c) =>
        c !== null &&
        typeof c === "object" &&
        "id" in c &&
        typeof (c as { id: unknown }).id === "string",
    );
    if (!ok) return null;
    return parsed as ContratoMarco[];
  } catch {
    return null;
  }
}

export function guardarContratosComoDefault(contratos: ContratoMarco[]): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY_DEFAULT, JSON.stringify(contratos));
}

export function borrarContratosDefault(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(STORAGE_KEY_DEFAULT);
}

export function existeContratosDefault(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(STORAGE_KEY_DEFAULT) !== null;
}
